import { generateHTML as convert } from '@tiptap/html'
import StarterKit from '@tiptap/starter-kit'
import { Color } from '@tiptap/extension-color'
import Text from '@tiptap/extension-text'
import TextStyle from '@tiptap/extension-text-style'
import Underline from '@tiptap/extension-underline'
import Document from '@tiptap/extension-document'
import TextAlign from '@tiptap/extension-text-align'
import Heading from '@tiptap/extension-heading'
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import Link from '@tiptap/extension-link'
import CustomImage from './editor/custom-image'
import CustomListItem from './editor/custom-list-item'
import CustomBlockquote from './editor/custom-blockquote'
import BackgroundColor from './editor/custom-background-color'
import PageBreak from './editor/page-break-node'

import './editor/TextHtmlEditorComponent.css'

const generateHTML = (data: any): string => {
  return convert(data, [
    BackgroundColor,
    StarterKit,
    Underline,
    Color,
    CustomImage.configure({
      HTMLAttributes: {
        class: 'custom-image',
      },
    }),
    TextStyle,
    TextAlign.configure({
      types: ['heading', 'paragraph'],
    }),
    Text,
    Heading,
    Document,
    Table.configure({
      HTMLAttributes: {
        class: 'custom-table',
      },
    }),
    TableCell,
    TableHeader,
    TableRow,
    Link.configure({
      openOnClick: false,
      linkOnPaste: true,
      autolink: true,
      protocols: ['ftp', 'mailto', 'https', 'http'],
    }),
    CustomListItem,
    PageBreak,
    CustomBlockquote,
  ])
}

export default generateHTML
